module.exports = __webpack_public_path__ + "static/media/block-auth.13baf541.svg";